"use strict";

exports.__esModule = true;
exports.historyPush = historyPush;

var _urlify = require("../../html/urlify");

var _router = require("@reach/router");

function historyPush(url) {
  return (0, _router.navigate)((0, _urlify.urlify)(url));
}